import { useQuery } from "react-query";
import { FileRevisionDto } from "../models/interfaces/dtos/file-revision-dto.ts";
import { PackDto } from "../models/interfaces/dtos/pack-dto.ts";
import ENDPOINTS from "../services/endpoints";
import { fetchItem } from "../queries/queries-helper";

const useProjectDetails = (baamerRevisionId: string) => {
    
    const packsQuery = useQuery<PackDto[]>(
        `packs/${baamerRevisionId}`,
        async () => {
            if (!baamerRevisionId) {
                return [];
            }

            return (await fetchItem<PackDto[]>(ENDPOINTS.PACK(baamerRevisionId)) ?? []);
        },
        {
            enabled: !!baamerRevisionId,
        }
    );

    const filesQuery = useQuery<FileRevisionDto[]>(
        `files/${baamerRevisionId}`,
        async () => {
            if (!baamerRevisionId) {
                return [];
            }
            return (await fetchItem<FileRevisionDto[]>(ENDPOINTS.FILE_REVISION(baamerRevisionId)) ?? []);
        },
        {
            enabled: !!baamerRevisionId,
        }
    );

    return {
        packs: packsQuery,
        files: filesQuery,
    };
};

export default useProjectDetails;
